import React from "react";
import { connect } from "react-redux";
import "./CanvasDebugger.scss";
import { showError } from "../../store/notifications/actions";
import { Tabs, Tab, TabPanel, AppBar } from "../../shared/components";
import TemplateTab from "./Template";
import FrameDataTab from "./FrameData";
import ParameterValuesTab from "./ParameterValues";
import { Slide, StorylineState } from "../../store/storyline/types";
import * as _ from "lodash";
import { RootState } from "../../store";

interface CanvasDebuggerProps {
    slide: Slide,
    frameData: object,
    storyline: StorylineState
}

function CanvasDebugger(props: CanvasDebuggerProps) {
    const { slide, frameData, storyline } = props;
    const [selectedTabIndex, setSelectedTabIndex] = React.useState(0);
    // The editor controls do not enjoy being used in a semi-headless state, so we add a small artificial delay between initial pop-up window render
    // and the time the editor is shown...
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        setTimeout(() => setLoading(false), 100);
    }, [])

    const handleTabChange = (event: React.ChangeEvent<{}>, newSelectedIndex: number) => {
        setSelectedTabIndex(newSelectedIndex);
    };

    return (
        <div className="canvas-debugger">
            <AppBar position="sticky" className="navbar">
                <Tabs
                    value={selectedTabIndex}
                    onChange={handleTabChange}
                    centered
                >
                    <Tab label="Metadata" />
                    <Tab label="Template" />
                    <Tab label="Frame Data" />
                    <Tab label="Parameter Values" />
                </Tabs>
            </AppBar>
            <TabPanel key="tab-0" selectedValue={selectedTabIndex} value={0}>
                {
                    loading ?
                        <div>Loading</div> :
                        <div className="screen-centered">
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <td className="heading-cell">
                                            Storyline ID
                                        </td>
                                        <td>
                                            {storyline.id}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="heading-cell">
                                            Storyline Name
                                        </td>
                                        <td>
                                            {storyline.name}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="heading-cell">
                                            Template ID
                                        </td>
                                        <td>
                                            {slide.template.id}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="heading-cell">
                                            Template Name
                                        </td>
                                        <td>
                                            {slide.template.name}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="heading-cell">
                                            Canvas ID
                                        </td>
                                        <td>
                                            {slide.canvasId}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="heading-cell">
                                            Canvas Name
                                        </td>
                                        <td>
                                            {slide.name}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="heading-cell">
                                            Datasource IDs
                                        </td>
                                        <td>
                                            {_.map(slide.datasourceIds, dsId => <div key={dsId}>{dsId}</div>)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                }
            </TabPanel>

            <TabPanel key="tab-1" selectedValue={selectedTabIndex} value={1}>
                {
                    loading ?
                        <div>Loading</div> :
                        <TemplateTab slide={slide} />
                }
            </TabPanel>

            <TabPanel key="tab-2" selectedValue={selectedTabIndex} value={2}>
                {
                    loading ?
                        <div>Loading</div> :
                        <FrameDataTab frameData={frameData} />
                }
            </TabPanel>

            <TabPanel key="tab-3" selectedValue={selectedTabIndex} value={3}>
                {
                    loading ?
                        <div>Loading</div> :
                        <ParameterValuesTab />
                }
            </TabPanel>
        </div>
    );
}

export default connect(
    (state: RootState) => ({
        storyline: state.storyline
    }),
    { showError })(CanvasDebugger);